import { ReactElement, useMemo } from 'react';
import { Divider, Stack, Typography, Button } from '@mui/material';
import {
  KeyboardArrowUpRounded as CollapseIcon,
  KeyboardArrowDownRounded as ExpandIcon,
} from '@mui/icons-material';

import { ZoneSaturationLevelType } from '~globals/types/enums';

import { useDashboardVariantV2CarrierContext } from '../../Context';
import { getZoneSaturationLevelColor } from '../utils';
import {
  DashboardVariantV2CarrierZoneSaturationHeaderContainer,
  DashboardVariantV2CarrierZoneSaturationHeaderLegend,
} from './styles';
import DashboardVariantV2CarrierZoneSaturationHeaderLegendItem from './LegendItem';

const DashboardVariantV2CarrierZoneSaturationHeader = (): ReactElement => {
  const {
    data: {
      zoneSaturation: {
        data: { totalSaturatedZones, totalOnAlertZones, totalWithMarginZones },
        expand: { value: expand, toggleValue: toggleExpand },
      },
    },
  } = useDashboardVariantV2CarrierContext();

  const legendItems = useMemo(
    () => [
      {
        key: 'saturated',
        count: totalSaturatedZones,
        label: 'saturada',
        color: getZoneSaturationLevelColor(ZoneSaturationLevelType.Saturated),
      },
      {
        key: 'on-alert',
        count: totalOnAlertZones,
        label: 'en alerta',
        color: getZoneSaturationLevelColor(ZoneSaturationLevelType.OnAlert),
      },
      {
        key: 'with-margin',
        count: totalWithMarginZones,
        label: 'con margen',
        color: getZoneSaturationLevelColor(ZoneSaturationLevelType.WithMargin),
      },
    ],
    [totalSaturatedZones, totalOnAlertZones, totalWithMarginZones],
  );

  return (
    <DashboardVariantV2CarrierZoneSaturationHeaderContainer
      divider={<Divider orientation="vertical" flexItem />}
    >
      <Stack direction="row" spacing={2}>
        <Typography component="h6" fontWeight="bold">
          Saturación por zona
        </Typography>

        <DashboardVariantV2CarrierZoneSaturationHeaderLegend>
          {legendItems.map((legend) => (
            <DashboardVariantV2CarrierZoneSaturationHeaderLegendItem
              key={legend.key}
              dotColor={legend.color}
              count={legend.count}
              label={legend.label}
              withPulse={legend.key === 'saturated' && legend.count > 0}
            />
          ))}
        </DashboardVariantV2CarrierZoneSaturationHeaderLegend>
      </Stack>

      <Button
        variant="text"
        size="small"
        onClick={() => toggleExpand()}
        endIcon={expand ? <CollapseIcon /> : <ExpandIcon />}
      >
        {expand ? 'Ocultar' : 'Mostrar'}
      </Button>
    </DashboardVariantV2CarrierZoneSaturationHeaderContainer>
  );
};

export default DashboardVariantV2CarrierZoneSaturationHeader;
